import { render, staticRenderFns } from "./ChangeRoleUser.vue?vue&type=template&id=570db41f"
import script from "./ChangeRoleUser.vue?vue&type=script&lang=js"
export * from "./ChangeRoleUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports